import 'shared/assets/application';
import 'shared/components/secondary_nav/secondary_nav.scss';
import '../components/footer_bar/footer-bar.scss'
import '../components/chat/chat.js';
import './spa_navigation_tracker';
